export default {"src":"https://fishbrain.com/_next/static/media/rocket.3f0ad824.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};